'use client';

import { useAuth } from '@ahm/react-auth';
import { useCallback, useMemo } from 'react';
import { useGetRemoteConfig } from '@/features/home/api/use-get-remote-config';
import { REMOTE_CONFIG_KEY } from '@/lib/constants';

export function useRemoteConfigHook() {
  const { session } = useAuth();

  const user = session?.user;
  const { data: remoteConfig } = useGetRemoteConfig({
    enabled: Boolean(user),
  });

  const getRemoteConfigValue = useCallback(
    (name: string) => {
      if (!remoteConfig) return null;
      const suffix =
        process.env.NEXT_PUBLIC_APP_ENV === 'production'
          ? ''
          : process.env.NEXT_PUBLIC_APP_ENV === 'uat'
            ? '_uat'
            : '_stg';

      try {
        const configValue =
          remoteConfig[`${name}${suffix}`]?.defaultValue?.value;
        if (!configValue) return null;
        return JSON.parse(configValue);
      } catch (error) {
        console.error(`Error parsing remote config for ${name}:`, error);
        return null;
      }
    },
    [remoteConfig]
  );

  const surgePriceConfig = useMemo(
    () => getRemoteConfigValue(REMOTE_CONFIG_KEY.SURGE_PRICE_DISPLAY_CONFIG),
    [getRemoteConfigValue]
  );

  const extendChatDurationConfig = useMemo(
    () => getRemoteConfigValue(REMOTE_CONFIG_KEY.CHAT_DURATION) || 0,
    [getRemoteConfigValue]
  );

  const tipsDeadlineConfig = useMemo(
    () => getRemoteConfigValue(REMOTE_CONFIG_KEY.USER_TIPS_DEADLINE_SEC) || 0,
    [getRemoteConfigValue]
  );

  return {
    remoteConfig,
    surgePriceConfig,
    extendChatDurationConfig,
    tipsDeadlineConfig,
  };
}
